import React from "react";
import { Card } from "@/components/ui/card";
import { DISCLAIMER_TEXT } from "@/lib/constants";
import { Clock } from "lucide-react";

export function Pending() {
  return (
    <div className="mx-auto max-w-md px-4 py-20 text-center">
      <div className="h-16 w-16 mx-auto rounded-2xl bg-primary/15 flex items-center justify-center text-primary">
        <Clock className="h-7 w-7" />
      </div>
      <h1 className="font-heading text-2xl mt-4">Awaiting approval</h1>
      <p className="text-muted-foreground mt-2 text-sm">
        Your account is pending admin approval. We'll notify you when access is granted.
      </p>
    </div>
  );
}

function LegalShell({ title, children }) {
  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="font-heading text-3xl sm:text-4xl tracking-tighter">{title}</h1>
      <Card className="p-6 border-border/60 mt-6 prose prose-sm dark:prose-invert max-w-none text-muted-foreground leading-relaxed space-y-4">
        {children}
      </Card>
    </div>
  );
}

export function Terms() {
  return (
    <LegalShell title="Terms & Conditions">
      <p>By using sanskariBazarIn you accept these terms. The platform is a private, members-only community space for business discovery.</p>
      <p>Membership is by referral and subject to admin approval. Fake referrals, abusive behaviour, or misrepresentation may lead to permanent blocking of the offending account and all associated referrals.</p>
      <p>All transactions, deliveries, taxes, and warranties are solely between consumer and vendor. sanskariBazarIn does not handle payments or moderate disputes.</p>
      <p><strong>Disclaimer:</strong> {DISCLAIMER_TEXT}</p>
    </LegalShell>
  );
}

export function Privacy() {
  return (
    <LegalShell title="Privacy Policy">
      <p>We collect only essential data needed to operate the platform: your name, email and profile picture from your Google login, plus business details you choose to publish as a vendor.</p>
      <p>We do not sell your data. Chats between members are stored to enable conversation history. Reports submitted against vendors are reviewed by admins.</p>
      <p>You can request data deletion at any time by contacting us.</p>
    </LegalShell>
  );
}

export function Disclaimer() {
  return (
    <LegalShell title="Disclaimer">
      <p>{DISCLAIMER_TEXT}</p>
      <p>Listings, ratings and vendor information are provided on a best-effort basis. Always verify business credentials independently before any transaction.</p>
    </LegalShell>
  );
}

export function Contact() {
  return (
    <LegalShell title="Contact">
      <p>For questions, partnerships or member support, write to <a className="text-primary underline" href="mailto:hello@sanskaribazar.in">hello@sanskaribazar.in</a>.</p>
      <p>For admin or referral issues, your superadmin pchitale@gmail.com is the primary point of contact.</p>
    </LegalShell>
  );
}
